import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useGeneros = () => {
  const [generos, setGeneros] = useState<EnumOption[]>([]);
  useEffect(() => {
    const fetchGeneros = async () => {
      try {
        const response = await httpClient.get(`/api/users/genero`);
        const options = response.data.map(
          (generos: { value: number; label: string }) => ({
            value: generos.value.toString(),
            label: generos.label,
          }),
        );
        setGeneros(options);
      } catch (error) {
        console.error('Erro ao buscar gêneros sexuais', error);
      }
    };
    fetchGeneros();
  }, []);

  return generos;
};
